import {
    ChartNoAxesCombined,
    ChartPie,
    FileStack,
    FlaskConical,
    Palette,
    Plug,
    ScanBarcode,
    ShoppingBag,
    Sparkles,
    Speech,
    Store,
    Users,
    Video,
} from 'lucide-react'

import {
    DEFAULT_LANDING_PATH,
    EMAIL_ANALYTICS_PATH,
    PAID_ANALYTICS_PATH,
} from './paths'
import { NavigationConfig } from './types'

export const navigationConfig: NavigationConfig = {
    mainItems: [
        {
            name: 'PAID ADVERTISING',
            value: 'paid',
            defaultOpen: true,
            items: [
                {
                    label: 'Create with AI',
                    value: 'createStorefront',
                    href: DEFAULT_LANDING_PATH,
                    enabled: true,
                    lucideIcon: Sparkles,
                },
                {
                    label: 'Storefronts',
                    value: 'storefront',
                    href: '/landingpages',
                    enabled: true,
                    lucideIcon: Store,
                },
                {
                    label: 'Bulk Create',
                    value: 'bulkLinkCreation',
                    href: '/linkcreation',
                    enabled: true,
                    lucideIcon: FileStack,
                },
                {
                    label: 'Experimentation',
                    value: 'paidExperimentation',
                    href: '/experiments/paid',
                    enabled: true,
                    lucideIcon: FlaskConical,
                },
                {
                    label: 'Analytics',
                    value: 'dashboard',
                    href: PAID_ANALYTICS_PATH,
                    enabled: true,
                    lucideIcon: ChartPie,
                },
                {
                    label: 'Meta Performance',
                    value: 'paidFunnelReport',
                    href: '/paid-funnel-report',
                    enabled: true,
                    lucideIcon: ChartNoAxesCombined,
                },
            ],
            enabled: true,
        },
        {
            name: 'EMAIL & SMS',
            value: 'emailAndSms',
            defaultOpen: false,
            items: [
                {
                    label: 'Create with AI',
                    value: 'emailAiChat',
                    href: '/emailandsms-postclick/create/ai-chat',
                    enabled: true,
                    lucideIcon: Sparkles,
                },
                {
                    label: 'Storefronts',
                    value: 'emailAndSmsStorefront',
                    href: '/emailandsms-postclick',
                    enabled: true,
                    lucideIcon: Store,
                },
                {
                    label: 'Experimentation',
                    value: 'emailSmsExperimentation',
                    href: '/experiments/email',
                    enabled: true,
                    lucideIcon: FlaskConical,
                },
                {
                    label: 'Analytics',
                    value: 'emailAnalytics',
                    href: EMAIL_ANALYTICS_PATH,
                    enabled: true,
                    lucideIcon: ChartPie,
                },
            ],
            enabled: true,
        },
        {
            name: 'ASSETS',
            value: 'assets',
            defaultOpen: false,
            items: [
                {
                    label: 'Personas',
                    value: 'personas',
                    href: '/personas',
                    enabled: true,
                    lucideIcon: Speech,
                },
                {
                    label: 'Products',
                    value: 'products',
                    href: '/products',
                    enabled: true,
                    lucideIcon: ScanBarcode,
                },
                {
                    label: 'Videos',
                    value: 'videos',
                    href: '/videos',
                    enabled: true,
                    lucideIcon: Video,
                },
            ],
            enabled: true,
        },
        {
            name: 'SETTINGS',
            value: 'settings',
            defaultOpen: true,
            items: [
                {
                    label: 'Brand Center',
                    value: 'brandCenter',
                    href: '/settings/brand/identity',
                    activePathPrefix: '/settings/brand',
                    enabled: true,
                    lucideIcon: Palette,
                },
                {
                    label: 'Shopper Experience',
                    value: 'shopperExperience',
                    href: '/settings/shopper/promotions',
                    activePathPrefix: '/settings/shopper',
                    enabled: true,
                    lucideIcon: ShoppingBag,
                },
                {
                    label: 'Integrations',
                    value: 'integrations',
                    href: '/settings/integrations/pixels',
                    activePathPrefix: '/settings/integrations',
                    enabled: true,
                    lucideIcon: Plug,
                },
                {
                    label: 'Account',
                    value: 'account',
                    href: '/settings/account/team',
                    activePathPrefix: '/settings/account',
                    enabled: true,
                    lucideIcon: Users,
                },
            ],
            enabled: true,
        },
    ],
    onboardNewClientLink: {
        label: 'Add new shop',
        value: 'onboardNewClient',
        href: '/onboarding?step=shopify-app-install',
        enabled: true,
        icon: 'plus',
    },
    userMenu: [
        {
            label: 'Users',
            value: 'users',
            href: '/settings/account/team',
            enabled: true,
            icon: 'team',
        },
        {
            label: 'Billing',
            value: 'billing',
            href: '/settings/account/billing',
            enabled: true,
            icon: 'credit-card',
        },
        {
            label: 'Support',
            value: 'supportCenter',
            href: 'https://blackcrow.zendesk.com/hc/en-us/categories/30800308031003-Product-Information-Paid-Storefronts',
            enabled: true,
            openInNewTab: true,
            icon: 'support-center',
        },
        {
            label: 'Referrals',
            value: 'referrals',
            href: 'https://black-crow-referrals.figma.site/',
            enabled: true,
            openInNewTab: true,
        },
        {
            label: 'Virtual products',
            value: 'virtualProducts',
            href: '/virtual-products',
            enabled: true,
            internalOnly: true,
        },
        {
            label: 'Product families',
            value: 'productFamilies',
            href: '/product-families',
            enabled: true,
            internalOnly: true,
        },
        {
            label: 'Swatches',
            value: 'swatches',
            href: '/product-options',
            enabled: true,
            internalOnly: true,
        },
        {
            label: 'Layout references',
            value: 'layoutReferences',
            href: '/layout-references',
            enabled: true,
            internalOnly: true,
        },
        {
            label: 'Prompt Lab',
            value: 'promptLab',
            href: '/prompt-lab',
            enabled: true,
            internalOnly: true,
        },
    ],
}
